import { Address } from "@wingspanhq/wingspan-api-sdk";
import { getValidationSchemaAddress } from "../../../shared/validators/address/validationSchemaAddress";

export const selectorCardShippingAddress = (
  address: Address | null | undefined
): Address | undefined => {
  if (!address) {
    return undefined;
  }

  const country = address.country || "US";

  const isValid = getValidationSchemaAddress(country).isValidSync({
    addressLine1: address.line1,
    addressLine2: address.line2,
    city: address.city,
    state: address.state,
    postalCode: address.postalCode
  });

  if (!isValid) {
    return undefined;
  }

  return {
    line1: address.line1,
    ...(address.line2 ? { line2: address.line2 } : {}),
    city: address.city,
    state: address.state,
    postalCode: address.postalCode,
    country
  };
};
